import React from "react";
import TitleIcon from '@mui/icons-material/Title';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import Slider from '@mui/material/Slider';

interface Props {
  setActiveOverlay?: (overlay: string) => void;
}

const TextSettingsSidebar: React.FC<Props> = ({ setActiveOverlay }) => {
  return (
    <>
      <div className="editor_card">
        <h3>Overlays</h3>
        <div className="overlay_tabs">
          <figure className="tab_btn active">
            <TitleIcon sx={{ fontSize: 20 }} />
            <figcaption>Text</figcaption>
          </figure>
          <figure className="tab_btn" onClick={() => setActiveOverlay?.('color')}>
            <ColorLensIcon sx={{ fontSize: 20 }} />
            <figcaption>Color</figcaption>
          </figure>
          <figure className="tab_btn" onClick={() => setActiveOverlay?.('upload')}>
            <img src="/static/images/upload.svg" alt="color_upload_icon" />
            <figcaption>Upload</figcaption>
          </figure>
        </div>
      </div>

      <div className="editor_card text_customization">
        <h3>Text Settings</h3>
        <div className="text_input_box">
          <input type="text" defaultValue="The Johnson Family" />
        </div>

        <div className="text_prop_row">
          <label>Font</label>
          <div className="inline_dropdown">
            <span>Playfair Display</span>
            <KeyboardArrowDownIcon className="arrow" />
          </div>
        </div>

        <div className="text_prop_row">
          <label>Style</label>
          <div className="inline_dropdown">
            <span>Semi Bold</span>
            <KeyboardArrowDownIcon className="arrow" />
          </div>
        </div>

        <div className="text_prop_row">
          <label>Size</label>
          <div className="slider_control">
            <Slider className="slider" defaultValue={48} min={0} max={100} />
            <span className="value">48</span>
          </div>
        </div>

        <div className="text_prop_row">
          <label>Color</label>
          <div className="color_box" style={{ background: '#fff' }}></div>
        </div>

        <div className="text_prop_row">
          <label>Alignment</label>
          <div className="alignment_group">
            <button className="align_btn"><FormatAlignLeftIcon sx={{ fontSize: 16 }} /></button>
            <button className="align_btn active"><FormatAlignCenterIcon sx={{ fontSize: 16 }} /></button>
            <button className="align_btn"><FormatAlignRightIcon sx={{ fontSize: 16 }} /></button>
          </div>
        </div>

        <div className="text_prop_row">
          <label>Letter Spacing</label>
          <div className="slider_control">
            <Slider className="slider" defaultValue={0} min={-100} max={100} />
            <span className="value">0%</span>
          </div>
        </div>

        <div className="text_prop_row">
          <label>Line Spacing</label>
          <div className="slider_control">
            <Slider className="slider" defaultValue={120} min={0} max={200} />
            <span className="value">120%</span>
          </div>
        </div>
      </div>

      <div className="editor_card">
        <h3>Layers</h3>
        <div className="layers_list">
          <div className="layer_item active_layer">
            <div className="layer_left">
              <span className="micro_img">
                <DragIndicatorIcon sx={{ fontSize: 14 }} />
              </span>
              <div className="thumb text_thumb">T</div>
              <div className="info">
                <strong>Family Name</strong>
                <span>Text</span>
              </div>
            </div>
            <div className="layer_right">
              <img src="/static/images/trash.svg" alt="" className="thumb" />

              <VisibilityIcon sx={{ fontSize: 18, color: '#fff', opacity: 0.5 }} />
            </div>
          </div>

          <div className="layer_item">
            <div className="layer_left">
              <span className="micro_img">
                <DragIndicatorIcon sx={{ fontSize: 14 }} />
              </span>
              <img src="/static/images/avtar.svg" alt="" className="thumb" />
              <div className="info">
                <strong>Family Photo</strong>
                <span>Image</span>
              </div>
            </div>
            <div className="layer_right">
              <img src="/static/images/trash.svg" alt="" className="thumb" />
              <VisibilityIcon sx={{ fontSize: 18, color: '#fff', opacity: 0.5 }} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TextSettingsSidebar;
